export default __webpack_public_path__ + "navigation-examples-route-lines-styling-960-79a83fe699008f9dcbfadfbf4acf05b1.webp";